export { FeaturedProduct } from './FeaturedProduct';
